import { baseURL } from "../../util/Constant";
import { getMessage } from "../redux/messageSlice";
import {
  getAllNewStatus,
  getStatus,
  loadStatus,
  updateStatusItem,
  getAllArchiveStatus,
  loadArchive,
} from "../redux/statusSlice";

//Get New Status
export const getNewStatusFetch = () => (dispatch) => {
    dispatch(loadStatus(false));
    fetch(`${baseURL}/status/get`, { method: "GET" })
      .then((res) => res.json())
      .then((data) => {
        if (data.errorCode) {
          dispatch(getMessage(data.message));
          return;
        }
         //console.log(data);
       dispatch(getAllNewStatus(data));
      })
      .catch((error) => {
        console.log(error);
      });
  };

  export const getAllStatusForArchiveFetch = () => (dispatch) => {
    dispatch(loadArchive(false));
    fetch(`${baseURL}/status/getAll`, { method: "GET" })
      .then((res) => res.json())
      .then((data) => {
        if (data.errorCode) {
          dispatch(getMessage(data.message));
          return;
        }
        dispatch(getAllArchiveStatus(data));
      })
      .catch((error) => {
        console.log(error);
      });
  };


  export const getStatusFetch = () => (dispatch) => {
    dispatch(loadStatus(false));
    fetch(`${baseURL}/status/chart`, { method: "GET" })
      .then((res) => res.json())
      .then((data) => {
        if (data.errorCode) {
          dispatch(getMessage(data.message));
          return;
        }
         //console.log(data);
       dispatch(getStatus(data));
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //Update Designer
export const putUpdateDesigner = (id, nameDesigner) => (dispatch) => {
   dispatch(loadStatus(false));
  fetch(`${baseURL}/status/updateDesigner`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ id, nameDesigner}),
  })
    .then((res) => res.json())
    .then((data) => {
      
    })
    .catch((error) => {
      console.log(error);
    });
};

 //Update Studio
 export const putUpdateStudio = (id, nameStatus) => (dispatch) => {
  
  
//   dispatch(loadStatus(false));
//  fetch(`${baseURL}/status/updateStudio`, {
//    method: "PUT",
//    headers: {
//      "Content-Type": "application/json",
//    },
//    body: JSON.stringify({ id}),
//  })
//    .then((res) => res.json())
//    .then((data) => {
     
//    })
//    .catch((error) => {
//      console.log(error);
//    });
};

export const putStatusComment = (id,comment, username) =>(dispatch) => {
  dispatch(loadStatus(false));
  
  fetch(`${baseURL}/status/updateComment`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ id,comment, username }),
  })
    .then((res) => res.json())
    .then((data) => {
    })
    .catch((error) => {
      console.log(error);
    });
}

//Update Status All
export const putUpdateStatusAll = (id, newStatus) => (dispatch) => {
  dispatch(loadStatus(false));
  fetch(`${baseURL}/status/updateStatusAll`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ id, newStatus }),
  })
    .then((res) => res.json())
    .then((data) => {
    })
    .catch((error) => {
      console.log(error);
    });
};

//Update Storage All
export const putUpdateStorageAll = (id, oldStatus, newStatus) => (dispatch) => {
  dispatch(loadStatus(false));
  fetch(`${baseURL}/status/updateStorageAll`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ id, oldStatus, newStatus }),
  })
    .then((res) => res.json())
    .then((data) => {
    })
    .catch((error) => {
      console.log(error);
    });
};

//Update Status
export const putUpdateStatus = (id, nameStatus) => (dispatch) => {
  dispatch(loadStatus(false));
  fetch(`${baseURL}/status/updateStatus`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ id, nameStatus }),
  })
    .then((res) => res.json())
    .then((data) => {
    })
    .catch((error) => {
      console.log(error);
    });
};

//Change status:false => true
export const putFinishStatusFetch = (id, name) => (dispatch) => {
  dispatch(loadStatus(false));
  fetch(`${baseURL}/status/finishStatus`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ id, name }),
  })
    .then((res) => res.json())
    .then((data) => {
    })
    .catch((error) => {
      console.log(error);
    });
};

//Change status:false => true
export const putReturnStatusFetch = (id) => (dispatch) => {
  console.log(12);
  
  dispatch(loadStatus(false));
  fetch(`${baseURL}/status/returnStatus`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ id }),
  })
    .then((res) => res.json())
    .then((data) => {
      dispatch(getAllStatusForArchiveFetch());
    })
    .catch((error) => {
      console.log(error);
    });
};

//Change status:false => true
export const putNewStatusFetch = (newOrder) => (dispatch) => {
  
  dispatch(loadStatus(false));
  fetch(`${baseURL}/status/newOrder`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(newOrder),
  })
    .then((res) => res.json())
    .then((data) => {
    })
    .catch((error) => {
      console.log(error);
    });
};


export const changePayFetch = (id) => (dispatch) => {
  dispatch(loadStatus(false));
  fetch(`${baseURL}/status/pay`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ id }),
  })
    .then((res) => res.json())
    .then((data) => {
    })
    .catch((error) => {
      console.log(error);
    });
};

export const changeDataFetch = (id, data) => (dispatch) => {
  console.log("🚀 Sending changeDataFetch:", { id, data });
  
  fetch(`${baseURL}/status/data`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ id, data }),
  })
    .then((res) => {
      console.log("📡 Response status:", res.status);
      return res.json();
    })
    .then((updated) => {
      console.log("✅ Response data:", updated);
      if (updated && updated._id) {
        dispatch(updateStatusItem(updated));
        console.log("✅ Redux updated with:", updated);
      }
    })
    .catch((error) => {
      console.error("❌ Error in changeDataFetch:", error);
    });
};

